import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import ViewToggle from './ViewToggle'
import AvailabilityAddButton from './AvailabilityAddButton'

function WeeklyCalendarToolbar({ activeTab, setActiveTab, onAddAvailability }) {
  const navigate = useNavigate()
  const { leagueId } = useParams()

  const currentView = activeTab === 'list' ? 'list' : 'week'

  const handleViewChange = (view) => {
    if (view === 'list') {
      setActiveTab('list')
      navigate(`/leagues/${leagueId}/schedule?tab=list`)
    } else if (view === 'week') {
      setActiveTab('calendar')
      navigate(`/leagues/${leagueId}/schedule`)
    } else if (view === 'month') {
      navigate(`/leagues/${leagueId}/schedule-month`)
    }
  }

  return (
    <div
      className="view-toggle-container mb-3"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <ViewToggle currentView={currentView} onViewChange={handleViewChange} />
      <AvailabilityAddButton
        className="fl__weekly-calendar-toolbar__add-button"
        onClick={onAddAvailability}
      />
    </div>
  )
}

WeeklyCalendarToolbar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  onAddAvailability: PropTypes.func.isRequired,
}

export default WeeklyCalendarToolbar
